import { FDContentContainer, FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import Footer from 'Components/ClientApp/Desktop/Footer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const useStyles = buildUseStyles('EndorserAgreementPage', () => ({
  footer: {
    position: 'sticky',
    transform: 'initial',
    bottom: 'unset',
  },
}));

export const Layout = () => {
  const {
    resource, onSubmit, saving,
  } = useMetaLayoutContext();
  const { refreshPageContentCollection } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();

  // Send Page Viewed Amplitude event
  useEventTrackingLogEvent({
    nodeName: 'Endorser Agreement',
    isPageView: true,
    pageViewEventProperties: {
      previouslySigned: !resource.meta().canPut(),
    },
  });

  const isMobile = useMobileLayout();
  const classes = useStyles();

  useBoneBackgroundColor();

  const onClick = async () => {
    try {
      await onSubmit();
      await refreshPageContentCollection();
    } catch (err) {
      displayErrorMessage(err, 'An unexpected error occurred. Please try again later.');
    }
  };

  return (
    <>
      <FDContentContainer maxWidth={'sm'}>
        <FDStack direction={'column'} spacing={4} paddingY={isMobile ? 4 : 8} flex={1}>
          <MetaControlField attr={'title'} {...dataAttrs('endorser agreement page title')} />
          <MetaControlField attr={'description'} {...dataAttrs('endorser agreement page description')} />
          <FDStack direction={'column'} paddingX={isMobile ? 4 : 8} width={'100%'} alignSelf={'center'} alignItems={'center'} spacing={2}>
            {resource.meta().canPut() && (
              <FDPrimaryActionButton
                isFullWidth
                onClick={onClick}
                label={resource.attr('primaryActionLabel') || 'Agree'}
                loading={saving}
                {...dataAttrs('endorser agreement agree btn')}
              />
            )}
            <MetaControlField attr="signedAt" />
          </FDStack>
        </FDStack>
      </FDContentContainer>
      {!isMobile && <Footer className={classes.footer} />}
    </>
  );
};
